import { gql } from "@apollo/client";

export default gql`
  mutation askAiSendRoutineTest($routineId: UUID!) {
    sendRoutineTest(routineId: $routineId) {
      ok
    }
  }
`;
